/* SW → PostHog bridge for cache-hit analytics.
 *
 * The service worker posts `lexiq:sw-cache-event` messages when it
 * serves an /api/... request from the API_CACHE (see service-worker.js).
 * This bridge listens on the main thread and forwards each event to
 * PostHog via the existing `track()` helper.
 *
 * Why go through a bridge instead of a direct fetch to /api/analytics?
 *   1) Zero backend work — reuses the analytics pipeline you already
 *      pay for.
 *   2) The SW cannot access `window.posthog`; only the main thread can.
 *   3) posthog-js batches captures + handles offline retry itself, so
 *      the SW's 50 % sampling + posthog's default 10-event batching
 *      keeps this to a handful of network calls per session.
 *
 * Events fired:
 *   • sw_cache_hit    — served from SW cache; `age_ms` is the age of
 *                        the cached response in milliseconds.
 *   • sw_cache_miss   — no cached copy existed; a plain network fetch
 *                        was returned.
 *   • sw_cache_stale  — cached copy existed but exceeded API_SWR_MAX_AGE
 *                        (24 h) so a fresh network fetch was used.
 *
 * Properties on each event:
 *   { path: "/api/laws", age_ms: number|null }
 */
import { track } from "./analytics";

let _installed = false;

export function installSwAnalyticsBridge() {
  if (_installed) return;
  if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
  _installed = true;

  navigator.serviceWorker.addEventListener("message", (e) => {
    const m = e.data;
    if (!m || m.type !== "lexiq:sw-cache-event") return;
    // eventName format: sw_cache_hit / sw_cache_miss / sw_cache_stale
    track(`sw_cache_${m.event}`, {
      path: m.path,
      age_ms: typeof m.age_ms === "number" ? m.age_ms : null,
    });
  });
}
